<template>
  <section class="footer-section">
    <div class="lower-footer-region">
      <b-container>
        <div class="footer-region-divider">
          <b-row>
            <b-col>
              <content-creator
                :settings="getBlobContents('footer-terms')"
                :permissions="contentCreatorPermissions"
                :is-visible="editContentCreator"
                :filestore="fileStore"
                name="footer-terms"
                class="footer-terms"
                @updateBlob="(data) => saveBlob('footer-terms', data)"
              />
            </b-col>
            <b-col
              md="4"
            >
              <footer-social
                :social-alignment="socialAlignment"
                :social-branding="socialBranding"
              />
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>

    <div class="disclaimer-footer-region">
      <b-container>
        <b-row>
          <b-col>
            <content-creator
              :settings="getBlobContents('footer-disclaimer')"
              :permissions="contentCreatorPermissions"
              :is-visible="editContentCreator"
              :filestore="fileStore"
              name="footer-disclaimer"
              allowed-widgets="wysiwyg-editor, advanced-wysiwyg-editor"
              @updateBlob="(data) => saveBlob('footer-disclaimer', data)"
            />
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="software-provider-footer-region">
      <b-container>
        <b-row class="justify-content-center">
          <b-col>
            <component :is="copyright" />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>

<script>
import contentCreatorMixin from 'src/app/content-creator-mixin'
import { asyncLoader, pageMixin } from '../page-footer-common'

export default {
  name: 'page-footer',
  mixins: [
    contentCreatorMixin,
    pageMixin
  ],
  asyncData: asyncLoader,
  asyncComponents: ['footer-social'],
  data: function() {
    return {
      filestoreName: 'website',
      collapsed: true,
      socialAlignment: 'align-right',
      socialBranding: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

::v-deep  .social-group {
  &.branded {
    .icon {
      color:white;
    }
  }
  .social-link {
    .social-icon {
    border-color:var(--main-footer-border-color);
    }
    .icon {
      color:var(--main-footer-link-color);
    }
    @include hover-focus {
      .icon {
        color:var(--main-link-color);
      }
    }
  }
}

::v-deep  .upper-footer-region {
  .logo-container {
    margin:0 auto;
    display:flex;
    justify-content: center;
  }

  .logo {
    width: var(--main-mobile-logo-width);
    @include media-breakpoint-up(sm) {
    width: var(--main-mobile-logo-width-sm);
    }
    @include media-breakpoint-up(md) {
    width: var(--main-mobile-logo-width-md);
    }
    @include media-breakpoint-up(lg) {
    width: var(--main-mobile-logo-width-lg);
    }
  }

}

::v-deep  .footer-navigation {
    display: flex;
  .footer-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding:0;
    margin:0;
  }
  .footer-list-item {
    justify-content: center;
    display:flex;
    margin-bottom:1em;
    a {
      display:flex;
      align-items: center;
    }
  }

::v-deep  &.align-left{
  flex-grow: 1;
  @include media-breakpoint-up(sm) {
  .footer-list {
    display: flex;
    flex-direction: row;
    text-align: left;
    align-items: center;
  }
  .footer-list-item {
    padding-right: 1em;
  }
  }
}
::v-deep  &.align-right {
.footer-list-item {
  padding-left:1em;
}
}
}

.footer-section {
  padding:3em 0em;
  background-color: var(--main-footer-background-color);
  color:var(--main-footer-text-color);
 ::v-deep a {
    color:var(--main-footer-link-color);
  }

.middle-footer-region,
.upper-footer-region,
.lower-footer-region {
  margin-bottom:2em;
}

.middle-footer-region {

 ::v-deep .link-list-item {
    .link-list-item-link {
    @include media-breakpoint-up(md) {
    justify-content: center;
    }
    }
  }
 ::v-deep .link-list-title {
    border-color:var(--main-footer-border-color);

    h3{
    font-size:1.4em;
    @include media-breakpoint-up(md) {
    margin: 0em auto;
    text-align: center;
    justify-content: center;
    width: 100%;
  }
  }
  }

  .footer-region-divider {
  @include media-breakpoint-up(md) {
    padding:2em 0em;
    border-top:1px solid;
    border-bottom:1px solid;
    border-color:var(--main-footer-border-color);
}
}
}

.footer-disclaimer {
  .wysiwyg-content {
    color:var(--main-footer-text-color);
  }
}
::v-deep  .social-group {
  ul {
    padding:0;
    margin:0;
  }
}
::v-deep  .footer-terms {
  ul {
    list-style: none;
    padding:0em;
    margin:0em;
  }

@include media-breakpoint-down(md) {
 margin-bottom:2em;
}
  .container {
    padding:0em;
    .navigation {
      @include media-breakpoint-down(sm) {
      flex-direction:column;
      align-items: center;
      }
      }
    .nav-link {
    margin-bottom:1em;
    @include media-breakpoint-up(md) {
    margin:0;
    padding-left:0em;
    }
    }
  }
}
}
.footer-software-provider {
  @include media-breakpoint-down(sm) {
    font-size:.867em;
  }
}
</style>
